import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    // CHARTS
    Bbchs: {
        meta: {
            i18nDescrKey: "bbchs",
            filters: ["plot-selection-nav-bar-item", "campaign-select-nav-bar-item", "farm-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/tiles/charts/Bbchs.vue"),
    },
    YieldTile: {
        meta: {
            i18nDescrKey: "resume-yeld",
            filters: [
                "plot-selection-nav-bar-item",
                "campaign-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/tiles/osService/YieldTile.vue"),
    },
    PreviousYearCropWidgetTile: {
        meta: {
            i18nDescrKey: "previous-year-crop",
            filters: [
                "plot-selection-nav-bar-item",
                "campaign-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "s-c-leader-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/tiles/osService/PreviousYearCropWidgetTile.vue"),
    },
    PlotMapPanguaneta: {
        meta: {
            i18nDescrKey: "plot-map-panguaneta",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "PANGUANETA",
        },
        component: () => import("./components/tiles/charts/PlotMapPanguaneta.vue"),
    },
    TotalYeld: {
        meta: {
            i18nDescrKey: "total-yeld",
            filters: [
                "variety-selection-nav-bar-item",
                "block-selection-nav-bar-item",
                "plot-selection-nav-bar-item",
                "campaign-select-nav-bar-item",
                "farm-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "PATFRUT",
        },
        component: () => import("./components/tiles/charts/TotalYeld.vue"),
    },
    VarietyYeld: {
        meta: {
            i18nDescrKey: "variety-yeld",
            filters: [
                "variety-selection-nav-bar-item",
                "block-selection-nav-bar-item",
                "plot-selection-nav-bar-item",
                "campaign-select-nav-bar-item",
                "farm-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "PATFRUT",
        },
        component: () => import("./components/tiles/charts/VarietyYeld.vue"),
    },
    ForestMonitor: {
        meta: {
            i18nDescrKey: "forest-monitor",
            filters: ["farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "PANGUANETA",
        },
        component: () => import("./components/tiles/charts/ForestMonitor.vue"),
    },
    MapHaPerFarm: {
        meta: {
            i18nDescrKey: "map-ha-per-farm",
            filters: ["s-c-leader-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/tiles/charts/MapHaPerFarm.vue"),
    },
    VarietyPerFarm: {
        meta: {
            i18nDescrKey: "variety-per-farm-year",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/tiles/charts/VarietyPerFarm.vue"),
    },
    CropPerFarm: {
        meta: {
            i18nDescrKey: "crop-per-farm",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD_PORTAL",
        },
        component: () => import("./components/tiles/charts/CropPerFarm.vue"),
    },
    PlotListChart: {
        meta: {
            i18nDescrKey: "plot-list",
            filters: ["s-c-leader-select-nav-bar-item", "farm-select-nav-bar-item", "campaign-select-nav-bar-item"],
            pinnable: true,
            tag: "STANDARD",
        },
        component: () => import("./components/tiles/charts/PlotListChart.vue"),
    },
    SatelliteIndexesMapChart: {
        meta: {
            i18nDescrKey: "plot-indexes-chart",
            filters: [
                "s-c-leader-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
            ],
            pinnable: true,
            tag: "SATELLITE_INDEXES",
        },
        component: () => import("./components/tiles/charts/satelliteIndexesMap/defaultTile.vue"),
    },

    CropProgressionDefaultChartTile: {
        meta: {
            i18nDescrKey: "crop-progression-chart",
            filters: [
                "s-c-leader-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "council-select-nav-bar-item",
                "province-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "CROP_MONITORING",
        },
        component: () => import("./components/tiles/charts/cropProgression/defaultTile.vue"),
    },
    ResidualHarvestDefaultChartTile: {
        meta: {
            i18nDescrKey: "residual-harvest-chart",
            filters: [
                "s-c-leader-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "council-select-nav-bar-item",
                "province-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "CROP_MONITORING",
        },
        component: () => import("./components/tiles/charts/residualHarvest/defaultTile.vue"),
    },

    CampaignProgressionChartTile: {
        meta: {
            i18nDescrKey: "campaign-progression",
            filters: [
                "s-c-leader-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "council-select-nav-bar-item",
                "province-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "CROP_MONITORING",
        },
        component: () => import("./components/tiles/charts/campaignProgression/CampaignProgression.vue"),
    },
    PlotStateMapTile: {
        meta: {
            i18nDescrKey: "plot-state-map",
            filters: [
                "s-c-leader-select-nav-bar-item",
                "farm-select-nav-bar-item",
                "campaign-select-nav-bar-item",
                "plot-selection-nav-bar-item",
                "council-select-nav-bar-item",
                "province-select-nav-bar-item",
            ],
            pinnable: true,
            tag: "CROP_MONITORING",
        },
        component: () => import("./components/tiles/charts/plotStateMap/defaultTile.vue"),
    },
    PieVariety: () => import("./components/tiles/charts/PieVariety.vue"),
    PieVarietySelection: () => import("./components/tiles/charts/PieVarietySelection.vue"),
    PieCrop: () => import("./components/tiles/charts/PieCrop.vue"),

    // CONTAINERS
    CropPlanContainer: () => import("./components/CropPlanContainer.vue"),
    CropDoubleTileContainerRight4on6: () => import("./components/CropDoubleTileContainerRight4on6.vue"),
    PlotDetailsContainerWPlanting: () => import("./components/PlotDetailsContainerWPlanting.vue"),
    PlotDetailsContainerWOPlanting: () => import("./components/PlotDetailsContainerWOPlanting.vue"),
    PlotGroupDetailsContainer: () => import("./components/PlotGroupDetailsContainer.vue"),
    OldCropPlanContainer: () => import("./components/OldCropPlanContainer.vue"),
    ParcelTenureContainer: () => import("./components/ParcelTenureContainer.vue"),
    CropPlanPlotAddContainer: () => import("./components/CropPlanContainerPlotAdd.vue"),
    CropPlanSingleTileContainer: () => import("./components/CropPlanSingleTileContainer.vue"),
    PlotGroupEditContainer: () => import("./components/PlotGroupEditContainer.vue"),

    // HOME VIEW
    AllPlots: () => import("./components/tiles/cropPlan/AllPlots.vue"),
    AllPlotsInMapTile: () => import("./components/tiles/cropPlan/AllPlotsInMapTile.vue"),
    AddCropPlanTile: () => import("./components/tiles/cropPlan/AddCropPlanTile.vue"),
    EditCropPlanTile: () => import("./components/tiles/cropPlan/EditCropPlanTile.vue"),
    MapPlotSelectedTile: () => import("./components/tiles/cropPlan/MapPlotSelectedTile.vue"),
    CropFilterSelectionTile: () => import("./components/tiles/cropFilter/CropFilterSelection.vue"),
    CropFilterListTile: () => import("./components/tiles/cropFilter/CropFilterList.vue"),
    CropFilterDetailTile: () => import("./components/tiles/cropFilter/CropFilterDetail.vue"),

    // DETAIL PLOT
    CroppedPlotTile: () => import("./components/tiles/plotDetails/CroppedPlotTile.vue"),
    PlotDetailsMapTile: () => import("./components/tiles/plotDetails/PlotDetailsMapTile.vue"),
    SubPlotTile: () => import("./components/tiles/plotDetails/SubPlotTile.vue"),
    BlockTile: () => import("./components/tiles/plotDetails/BlockTile.vue"),
    VarietyTile: () => import("./components/tiles/plotDetails/VarietyTile.vue"),
    VarietyDetailTile: () => import("./components/tiles/plotDetails/VarietyDetailTile.vue"),
    PlantingTile: () => import("./components/tiles/plotDetails/PlantingTile.vue"),
    PlantingDetailTile: () => import("./components/tiles/plotDetails/PlantingDetailTile.vue"),
    MapBlockSelectedTile: () => import("./components/tiles/plotDetails/MapBlockSelectedTile.vue"),
    PhenologyTile: () => import("./components/tiles/plotDetails/PhenologyTile.vue"),
    FailureCountTile: () => import("./components/tiles/plotDetails/FailureCountTile.vue"),
    CropPreviousYearTile: () => import("./components/tiles/osService/CropPreviousYearTile.vue"),

    // PLOT GROUP
    PlotGroupList: () => import("./components/tiles/plotGroup/PlotGroupList.vue"),
    PlotGroupMap: () => import("./components/tiles/plotGroup/PlotGroupMap.vue"),
    PlotGroupPlotsInGroup: () => import("./components/tiles/plotGroup/PlotGroupPlotsInGroup.vue"),
    PlotGroupPlotsInGroupMap: () => import("./components/tiles/plotGroup/PlotGroupPlotsInGroupMap.vue"),
    PlotGroupPlotList: () => import("./components/tiles/plotGroup/PlotGroupPlotList.vue"),

    // OLD CROP PLAN
    OldCropPlanIframe: () => import("./components/tiles/oldCropPlan/OldCropPlanIframe.vue"),

    // PARCEL MANAGEMENT
    ManageParcelAssociation: () => import("./components/tiles/plotsParcelAssociation/ManageParcelAssociation.vue"),
    AssociateOrDisassociateParticles: () =>
        import("./components/tiles/plotsParcelAssociation/AssociateOrDisassociateParticles.vue"),
    //PARCEL TENURE
    ParcelTenureIframe: () => import("./components/tiles/oldParcelTenure/ParcelTenureIframe.vue"),

    VarietySelectionNavBarItem: () => import("./components/navbar/VarietySelectionNavBarItem.vue"),
    CropSelectionNavBarItem: () => import("./components/navbar/CropSelectionNavBarItem.vue"),

    QrCodeGenerationTile: () => import("./components/tiles/qrCode/qrCodeGenerationTile.vue"),

    TreeRowsDigitalizationTile: () => import("./components/tiles/plotDetails/TreeRowsDigitalization.vue"),

};

export default globals;
